module.exports = "/_next/static/images/gm-5bbf7b744147a5a95e5d65ae10ac2269.svg";